import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async index(payload = {}) {
        const response = await axios.get('v1/accounts', { params: payload });

        return response.data.data;
    },

    async store(payload = {}) {
        const response = await axios.post('v1/accounts', payload);

        return response.data.data;
    },

    async show(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/accounts/${id}`, {
            params: payload,
        });

        return response.data.data;
    },

    async update(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.put(`v1/accounts/${id}`, payload);

        return response.data.data;
    },

    async destroy(id) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.delete(`v1/accounts/${id}`);

        return response.data.data;
    },

    async fetchCampaigns(accountId) {
        if (!accountId) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/accounts/${accountId}/campaigns`);

        return response.data.data;
    },
};
